import {
  FETCH_PENDING_APPROVALLIST_REQUEST,
  FETCH_PENDING_APPROVALLIST_SUCCESS,
  FETCH_PENDING_APPROVALLIST_FAILURE,
} from "./PendingApprovalListActionTypes";

const initialState = {
  loading: false,
  pendingApprovalList: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PENDING_APPROVALLIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PENDING_APPROVALLIST_SUCCESS:
      return {
        loading: false,
        pendingApprovalList: action.payload,
        error: "",
      };
    case FETCH_PENDING_APPROVALLIST_FAILURE:
      return {
        loading: false,
        pendingApprovalList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
